import script from "./AdvisorNewFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvisorNewFormView.vue?vue&type=script&setup=true&lang=js"

import "./AdvisorNewFormView.vue?vue&type=style&index=0&id=ce14f73e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce14f73e"]])

export default __exports__